import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import {Skeleton} from '@chakra-ui/react';

const SkeletonItem: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <Skeleton width={'40px'} height={'20px'} className={classNames(styles.skeleton)} />
      <Skeleton width={'100%'} height={'120px'} className={classNames(styles.skeleton)} />
      <Skeleton width={'100%'} height={'8px'} className={classNames(styles.skeleton)} />
      <div className={styles.hr} />
      <div className={styles.row}>
        <Skeleton width={'100px'} height={'8px'} className={classNames(styles.skeleton)} />
        <Skeleton width={'100px'} height={'8px'} className={classNames(styles.skeleton)} />
      </div>
    </div>
  );
};

export default SkeletonItem;
